import React from "react";
//#region types
import { EditableFormInnerProps, GenericFormField } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import useCheckVisibility from "./hooks/useCheckVisibility";
import useGetHasValueCountWithContext from "./hooks/useGetHasValueCountWithContext";
import useCheckHasEditableField from "./hooks/useCheckHasEditableField";
import FormRow from "./formRow";
import { FormEnums } from "models/enums";
//#endregion

function ReadOnlyFormInnerFields<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { getFieldHidden } = useCheckVisibility<T>();
  const { getHasValueCount } = useGetHasValueCountWithContext<T>();
  const { getHasEditableField } = useCheckHasEditableField<T>();

  const fields = props.fields as Record<keyof T, GenericFormField<T>>;
  const fullWidthTypes = [FormEnums.FormFieldType.EDITABLETABLE, FormEnums.FormFieldType.TABLELIST];

  return (
    <>
      {Object.entries(fields).map(([key, field], index) => {
        return !getFieldHidden(field.hidden) ? (
          getHasEditableField(field) ? (
            <FormRow<T>
              {...props}
              key={`formField-${index}`}
              name={key}
              field={field}
              inline={false}
              enableControlLables
            />
          ) : getHasValueCount(field, key) ? (
            <FormRow<T>
              {...props}
              key={`formField-${index}`}
              name={key}
              field={{ ...field, descriptionText: undefined, readonly: true }}
              inline={false}
              contentWidth={fullWidthTypes.includes(field.type) ? 12 : 6}
              hideErrorBubble
            />
          ) : (
            <React.Fragment key={`formField-${index}`}></React.Fragment>
          )
        ) : (
          <React.Fragment key={`formField-${index}`}></React.Fragment>
        );
      })}
    </>
  );
}

export default ReadOnlyFormInnerFields;
